import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { employee_id, employee_name } from "../../../environment";
import { getFinancialYearList } from "../../../core/common/financialYear";

const GoalsProfileUpdate = () => {
  const params = useParams()
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());
  const [allEmpList, setAllEmpList] = useState<any[]>([]);
  const pms_category_Id = localStorage.getItem("pms_category_id");


  const navigate = useNavigate();
  const [count, setCount] = useState(1);
  const [newItem, setNewItem] = useState<any>({
    category_id: "",
    category_name: "",
    description: "",
  });

  const {
    data: getcategoryResponse,
    loading: getCategoryLoading,
    error: getCategoryError,
  } = useApi("/api/manager/view-category", {
    // } = useApi("/api/manager/view-employees-by-category", {
    method: "POST",
    payload: {
      category_id: pms_category_Id || "",
      financial_year: params.financial_year,
    },
    autoCall: true,
    dependencies: [count, finance_year],
  });

  useEffect(() => {
    if (getcategoryResponse?.data) {
      const response = getcategoryResponse.data;

      setNewItem({
        category_id: response.category_id,
        category_name: `${employee_id}_${employee_name}_${params.financial_year}`,
        description: response.category_description,
      });

      // const selectedIds = response.assignedEmployee.map(
      //   (emp: any) => emp.employee_id
      // );
      // setSelectedEmployees(selectedIds);
      // const promoMap: { [id: string]: boolean } = {};
      // response.assignedEmployee.forEach((emp: any) => {
      //   promoMap[emp.employee_id] = emp.is_eligible_promotion === "Yes";
      // });
      // setPromotionEligibleMap(promoMap);
    }
  }, [getcategoryResponse]);

  const getInputData = (e: any) => {
    const { name, value } = e.target;
    setNewItem({ ...newItem, [name]: value });
  };



  const {
    data: assignGoalsResponse,
    loading: postassignGoalsLoading,
    error: postassignGoalsError,
    callApi: postAssignGoalsData,
  } = useApi("/api/manager/edit-category", {
    method: "POST",
    autoCall: false,
  });

  const AddNewItem = async (e: any) => {
    e.preventDefault();
    const payload = {
      category_id: pms_category_Id,
      category_description: newItem.description,
      category_name: `${employee_id}_${employee_name}_${params.financial_year}`,
      employee_ids: [
        {
          employee_id: employee_id,
          is_eligible_promotion: "Yes",
        },
      ],
    };
    try {
      const response = await postAssignGoalsData(payload);
      console.log(response);
      if (response.success) {
        localStorage.setItem("pms_category_id", response?.data.category_id);
        localStorage.setItem("pms_category_name", response?.data.category_name);
        navigate(`/pms-kra-profile/${response?.data.financial_year}`);
        setNewItem({
          category_id: "",
          category_name: "",
          description: "",
        });
        setAllEmpList([]);
      }
    } catch (error: any) {
      console.error("Error while adding :", error);
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "There was a problem adding the category.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const clearCategoryId = () => {
    localStorage.removeItem("pms_category_id");
    localStorage.removeItem("pms_category_name");
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Goal Profile</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Goals Profile</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    My Goal
                  </li>

                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={params.financial_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                  disabled
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          {/* Goals Profile Form */}
          <div className="card mb-4">
            <div className="card-header">
              <h5>Create Goals Profile</h5>
            </div>
            <div className="card-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">Goals Profile Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter profile name"
                    name="category_name"
                    onChange={getInputData}
                    value={newItem.category_name}
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Goals Profile Description
                  </label>
                  <textarea
                    className="form-control"
                    rows={10}
                    placeholder="Enter profile description"
                    name="description"
                    onChange={getInputData}
                    value={newItem.description}
                    required
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="d-flex justify-content-end mb-5 px-3">
              <div className="d-flex gap-2">
                <Link
                  to="/pms-goals-summary"
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={clearCategoryId}
                >
                  <i className="bi bi-arrow-left ms-2"></i>Back
                </Link>
                <button className="btn btn-primary custom_button" onClick={AddNewItem}>
                  Add KRA<i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default GoalsProfileUpdate;
